import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import { FiSave, FiRefreshCw } from 'react-icons/fi';
import toast from 'react-hot-toast';

const ConfigContrato = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    empresa_nome: '',
    empresa_cnpj: '',
    empresa_endereco: '',
    template_text: ''
  });

  useEffect(() => {
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    try {
      const response = await api.get('/api/config-contrato');
      setFormData(response.data);
    } catch (error) {
      toast.error('Erro ao carregar configuração do contrato');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      await api.put('/api/config-contrato', formData);
      toast.success('Configuração do contrato salva com sucesso!');
    } catch (error) {
      toast.error(error.response?.data?.error || 'Erro ao salvar configuração');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-sky-600"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-white">Configuração do Contrato de Passageiros</h1>
          <p className="text-white/70 mt-1">Edite os termos e condições do contrato de passageiros</p>
        </div>
        <button
          onClick={fetchConfig}
          className="flex items-center gap-2 px-4 py-2 bg-sky-600 text-white rounded-lg hover:bg-sky-700 transition-colors"
        >
          <FiRefreshCw size={18} />
          Recarregar
        </button>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Dados da Empresa */}
        <div className="bg-sky-50 rounded-lg p-6">
          <h2 className="text-xl font-bold text-gray-900 mb-4">Dados da Empresa (Contratante)</h2>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Nome da Empresa *
              </label>
              <input
                type="text"
                value={formData.empresa_nome}
                onChange={(e) => setFormData({ ...formData, empresa_nome: e.target.value })}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-500 bg-white text-gray-800"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                CNPJ *
              </label>
              <input
                type="text"
                value={formData.empresa_cnpj}
                onChange={(e) => setFormData({ ...formData, empresa_cnpj: e.target.value })}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-500 bg-white text-gray-800"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Endereço *
              </label>
              <input
                type="text"
                value={formData.empresa_endereco}
                onChange={(e) => setFormData({ ...formData, empresa_endereco: e.target.value })}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-500 bg-white text-gray-800"
                required
              />
            </div>
          </div>
        </div>

        {/* Template único do Contrato */}
        <div className="bg-sky-50 rounded-lg p-6 space-y-4">
          <div className="flex items-center justify-between gap-4">
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-1">Texto do Contrato (Template Único)</h2>
              <p className="text-sm text-gray-600">
                Digite aqui todo o texto do contrato em um único campo. Os dados da empresa, do passageiro
                e da viagem serão incluídos automaticamente no PDF quando você gerar o contrato no cadastro
                do passageiro.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-lg border border-sky-100 p-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Texto do contrato *
            </label>
            <textarea
              value={formData.template_text || ''}
              onChange={(e) => setFormData({ ...formData, template_text: e.target.value })}
              rows="18"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-500 bg-white text-gray-800 font-mono text-sm"
              required
            />
          </div>
        </div>

        {/* Botão de Salvar */}
        <div className="flex justify-end">
          <button
            type="submit"
            disabled={saving}
            className="flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <FiSave size={18} />
            {saving ? 'Salvando...' : 'Salvar Configuração'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ConfigContrato;
